import "core-js/modules/web.dom.iterable";
//
//
//
//
import barLineChart from '@/components/bigDataChart/barLineChart';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryCurveAnalysisSx } from '@/api/api';
import moment from 'moment';
export default {
  name: 'waterStatistics',
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  components: {
    barLineChart: barLineChart
  },
  mounted: function mounted() {
    this.queryWaterWenStatistics();
  },
  methods: {
    queryWaterWenStatistics: function queryWaterWenStatistics() {
      var _this = this;

      var dateTime = new Date();
      var that = this;
      var yAxisData1 = [];
      var yAxisData2 = [];
      var yAxisData3 = [];
      var yAxisData4 = [];
      var xAxisData = [];
      queryCurveAnalysisSx({
        factorCategory: '12',
        id: '8',
        type: 0
      }).then(function (res) {
        if (res.success) {
          res.result.data.forEach(function (element) {
            yAxisData1.push(element.dataCodeMap['u21901'].value);
            yAxisData2.push(element.dataCodeMap['u22001'].value);
            yAxisData3.push(element.dataCodeMap['u22101'].value);
            yAxisData4.push(element.dataCodeMap['u20201'].value);
            xAxisData.push(element.dateStr);
          });
          var data = {
            color: ['#8B5CFF', '#00CA69', '#898b37', '#ff9900'],
            title: ['泵站前水位', '隧洞前水位', '原水水位', '流量'],
            xAxisData: xAxisData,
            yAxisList: [yAxisData1, yAxisData2, yAxisData3, yAxisData4],
            unit: '',
            height: 150
          };

          _this.$refs.chart3.initBarLineChart(data);
        }
      });
    }
  }
};